import Svg from "./Svg";

export default function LossIcon() {
  return (
    <Svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" fill="#FDECED" />
      <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="#D22839" />
      <path
        d="M5.59551 10.5V3.83H6.39551V9.79H8.79551V10.5H5.59551Z"
        fill="#D22839"
      />
    </Svg>
  );
}
